document.addEventListener("alpine:init", () => {
    window.Alpine.data("bookingModule", () => ({
        activeTab: "meetings",
        config: {},
        meetingDate: "",
        meetingParticipants: "",
        meetingStartTime: "",
        meetingEndTime: "",
        selectedMeetingHotels: [],
        stayArrival: "",
        stayDeparture: "",
        stayGuests: "",
        stayHotel: "",
        companyDate: "",
        companyGuests: "",
        companyOccasion: "",
        companyHotel: "",
        meetingHotelsOpen: false,
        timeRangeOpen: false,
        error: "",

        init() {
            const configElement = this.$root.querySelector("[data-booking-module-config]");
            this.config = JSON.parse(configElement?.textContent || "{}");
            this.activeTab = this.config.initialTab || "meetings";
            const currentHotel = this.config.currentHotelCode || "";
            this.selectedMeetingHotels = currentHotel ? [currentHotel] : [];
            this.stayHotel = currentHotel;
            this.companyHotel = currentHotel;
        },

        selectTab(tab) {
            this.activeTab = tab;
            this.error = "";
        },

        moveTab(event, direction) {
            const tabs = ["meetings", "stay", "companies"];
            const nextIndex = (tabs.indexOf(this.activeTab) + direction + tabs.length) % tabs.length;
            this.selectTab(tabs[nextIndex]);
            event.currentTarget.parentElement.querySelector(`[data-booking-tab="${tabs[nextIndex]}"]`)?.focus();
        },

        meetingHotelLabel() {
            if (!this.selectedMeetingHotels.length) return this.config.text.allLabel;
            if (this.selectedMeetingHotels.length === 1) return this.hotelName(this.selectedMeetingHotels[0]);
            return `${this.selectedMeetingHotels.length} ${this.config.text.selectedHotelsLabel}`;
        },

        timeRangeLabel() {
            if (!this.meetingStartTime && !this.meetingEndTime) return this.config.text.allLabel;
            return [this.meetingStartTime, this.meetingEndTime].filter(Boolean).join(" – ");
        },

        hotelName(code) {
            return this.config.hotels.find((hotel) => hotel.code === code)?.name || code;
        },

        submitMeetings() {
            this.error = "";
            if (!this.config.meetingUrl) return this.fail(this.config.text.missingDestinationError);
            if (!this.meetingDate || !this.positiveInteger(this.meetingParticipants)) {
                return this.fail(this.config.text.requiredFieldsError);
            }
            if (this.meetingStartTime && this.meetingEndTime && this.meetingEndTime <= this.meetingStartTime) {
                return this.fail(this.config.text.invalidTimeRangeError);
            }

            const url = new URL(this.config.meetingUrl, window.location.origin);
            url.searchParams.set("preferredDateFrom", this.meetingDate);
            url.searchParams.set("participants", this.meetingParticipants);
            if (this.meetingStartTime) url.searchParams.set("startTime", this.meetingStartTime);
            if (this.meetingEndTime) url.searchParams.set("endTime", this.meetingEndTime);
            const hotels = this.selectedMeetingHotels.length
                ? this.selectedMeetingHotels
                : this.config.hotels.map((hotel) => hotel.code);
            if (hotels.length) url.searchParams.set("hotels", hotels.join(","));
            window.location.assign(url.toString());
        },

        submitStay() {
            this.error = "";
            const hotel = this.config.hotels.find((item) => item.code === this.stayHotel);
            if (!hotel?.stayBaseUrl) return this.fail(this.config.text.missingDestinationError);
            if (!this.stayArrival || !this.stayDeparture || !this.positiveInteger(this.stayGuests)) {
                return this.fail(this.config.text.requiredFieldsError);
            }

            const arrival = this.parseDate(this.stayArrival);
            const departure = this.parseDate(this.stayDeparture);
            const lengthOfStay = Math.round((departure - arrival) / 86400000);
            if (!arrival || !departure || lengthOfStay < 1) return this.fail(this.config.text.invalidDateRangeError);

            const url = new URL(hotel.stayBaseUrl);
            url.searchParams.set("arrivaldate", this.stayArrival);
            url.searchParams.set("enddate", this.stayDeparture);
            url.searchParams.set("lengthofstay", lengthOfStay.toString());
            url.searchParams.set("roomcounts", `${this.stayGuests},0,0`);
            window.location.assign(url.toString());
        },

        submitCompanies() {
            this.error = "";
            if (!this.config.companyUrl) return this.fail(this.config.text.missingDestinationError);
            if (!this.companyDate || !this.positiveInteger(this.companyGuests)
                || !this.companyOccasion.trim() || !this.companyHotel) {
                return this.fail(this.config.text.requiredFieldsError);
            }

            const url = new URL(this.config.companyUrl, window.location.origin);
            url.searchParams.set("eventDate", this.companyDate);
            url.searchParams.set("guestCount", this.companyGuests);
            url.searchParams.set("occasion", this.companyOccasion.trim());
            url.searchParams.set("hotelCode", this.companyHotel);
            window.location.assign(url.toString());
        },

        parseDate(value) {
            const [year, month, day] = value.split("-").map(Number);
            return year && month && day ? Date.UTC(year, month - 1, day) : 0;
        },

        positiveInteger(value) {
            return /^\d+$/.test(value) && Number(value) > 0;
        },

        fail(message) {
            this.error = message;
            this.$nextTick(() => this.$root.querySelector("[data-booking-error]")?.focus());
        },
    }));
});
